import { makeStyles } from "@material-ui/core/styles";

export const useClinicalTrialConfigStyles = makeStyles((theme) => ({
  root: {
    width: "50%",
  },
  card: {
    width: "98%",
    marginTop: 16,
  },
  dialogTitle: {
    backgroundColor: theme.palette.primary.light,
  },
  infoBlock: {
    marginTop: 10,
  },
  sensitiveButton: {
    [theme.breakpoints.down("sm")]: {
      maxWidth: "none",
      width: "100%",
    },
    marginTop: "20px",
    width: "200px",
  },
}));
